enum StopType {
  INSTITUTION = "institution",
  ACCESSIBILITY = "accessibility",
  DINING = "food/dining",
  PARKING = "parking",
  RESTROOM = "restrooms",
  RECREATION = "recreation/entertainment",
  EMERGENCY = "emergency services",
}

export default StopType;
